import { ScreenUrl } from '../router/url';
import { ActionName } from './modules/application_form/types';

export namespace AppContext {
    /**
     * アプリ内部設定
     */
    export namespace InternalConfig {
        export namespace LocalStorage {
            export const AUTH_KEY = 'sio_auth';
            export const AUTH_NODE_SAML_KEY = 'sio_auth_node_saml';
        }
    }

    /**
     * システムエラーメッセージ集
     */
    export namespace Error {
        export const Unexpected = {
            CODE: 'WEB_F_0000001',
            MESSAGE_KEY: 'An_unexpected_error_occurred',
        };
        export const Unexpected5XX = {
            CODE: 'WEB_F_0000002',
            MESSAGE_KEY: 'The_server_may_be_experiencing_some_kind_of_failure',
        };
        export const Unexpected4XX = {
            CODE: 'WEB_F_0000003',
            MESSAGE_KEY: 'There_is_a_possibility_that_the_request_was_incomplete',
        };
        export const GateWayTimeout = {
            CODE: 'WEB_F_0000004',
            MESSAGE_KEY: 'Request_is_timeout,_please_confirm_result_later',
        };
        export const FileReadFailure = {
            CODE: 'WEB_F_0000005',
            MESSAGE_KEY: 'File_read_error_occurred',
        };
    }

    /**
     * 画面上の各種非同期操作に対する通知メッセージ一覧
     */
    export namespace MessageKey {
        export namespace Auth {
            export const HARD_DEVICE_REGISTED = 'Successfully_registered_to_the_hardware_token';
            export const SOFT_DEVICE_REGISTED = 'Successfully_registered_with_Google_Authenticator';
            export const SEND_UNLOCK_MAIL = 'Successfully_re-sent_the_unlocked_email';
            export const SEND_PASSWORD_RESET_MAIL = 'Successfully_sent_a_password_reset_email';
            export const SEND_UNCONFIRMED_MAIL = 'Successfully_re-sent_a_confirmation_email';
        }
        export namespace User {
            export const CREATED = 'Created_name';
            export const UPDATED = 'User_updated';
            export const DESTROYED = 'User_deleted';
            export const UNLOCKED = 'Unlocked';
            export const EXPIRED = 'Successfully_changed_the_revocation_status_of_the_user';
            export const IMPORTED = 'Domain_users_synced';
            export const IMPORTED_IDP = 'IdP_users_synced';
            export const PASSWORD_UPDATED = 'Password_updated';
            export const MULTIFACTOR_AUTH = 'Multifactior_auth_setting_changed';
            export const PERSONAL_SETTING_UPDATE = 'Updated';
            export const ACCESS_KEY_CREATE = 'Successfully_create_access_key';
            export const ACCESS_KEY_UPDATE = 'Successfully_changed_access_key_enabled';
            export const ACCESS_KEY_DELETE = 'Successfully_delete_access_keys';
            export const SESSION_TOKEN = 'Successfully_get_session_token';
        }
        export namespace UserGroup {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Group_updated';
            export const DESTROYED = 'Group_deleted';
            export const ADD_USERS = 'User_was_added_to_the_group';
            export const REMOVE_USERS = 'User_excluded_from_group';
        }
        export namespace Node {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Node_updated';
            export const DESTROYED = 'Node_deleted';
            export const CONNECTED = 'Connection_succeeded';
            export const ADD_APPS = 'Added_auto_login_app_definition_to_the_node';
            export const REMOVE_APPS = 'Excluded_auto_login_app_definition_from_the_node';
            export const ADD_EXCLUDES = 'Added_node_login_history_exclude_condition_to_the_node';
            export const REMOVE_EXCLUDES = 'Excluded_node_login_history_exclude_condition_from_the_node';
            export const RANDOMIZE_MANAGEMENT_PASSWORD_OR_SSH_KEY = 'Password_updated';
            export const SAML_CERTIFICATE_REISSUE = 'Successfully_the_certificate_reissued';

            export namespace NodeAccount {
                export const MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY = 'Password_changing_started';
            }
            export namespace DomainAccount {
                export const CREATED = 'Added_worker_account_(_domain_)_to_the_node';
                export const DESTROYED = 'Excluded_the_worker_account_(_domain_)_from_the_node';
            }
            export namespace OsAccount {
                export const CREATED = 'Added_worker_account_(_OS_)_to_the_node';
                export const UPDATED = 'Node_OS_account_updated';
                export const DESTROYED = 'Excluded_the_worker_account_(_OS_)_from_the_node';
                export const CONNECTED = 'Connection_succeeded';
            }
            export namespace OtherAccount {
                export const CREATED = 'Added_worker_account_(_other_)_to_the_node';
                export const UPDATED = 'Node_other_account_updated';
                export const DESTROYED = 'Excluded_the_worker_account_(_other_)_from_the_node';
                export const CONNECTED = 'Connection_succeeded';
            }
            export namespace IdpAccount {
                export const CREATED = 'Added_worker_account_(_IdP_)_to_the_node';
                export const DESTROYED = 'Excluded_the_worker_account_(_IdP_)_from_the_node';
            }
        }
        export namespace NodeDomain {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Node_domain_updated';
            export const DESTROYED = 'Node_domain_deleted';
            export const CONNECTED = 'Connection_succeeded';
            export const RANDOMIZE_MANAGEMENT_PASSWORD = 'Password_updated';
        }
        export namespace DomainAccount {
            export const CREATED = 'Node_domain_accounts_registered';
            export const UPDATED = 'Node_domain_account_updated';
            export const DESTROYED = 'Node_domain_accounts_unregistered';
            export const CONNECTED = 'Connection_succeeded';
        }
        export namespace NodeIdp {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Node_idp_updated';
            export const DESTROYED = 'Node_idp_deleted';
            export const CONNECTED = 'Connection_succeeded';
        }
        export namespace IdpAccount {
            export const CREATED = 'Node_idp_accounts_registered';
            export const DESTROYED = 'Node_idp_accounts_unregistered';
        }
        export namespace NodeGroup {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Node_group_updated';
            export const DESTROYED = 'Node_group_deleted';
            export const ADD_NODES = 'Node_was_added_to_the_group';
            export const REMOVE_NODES = 'Node_excluded_from_group';
        }
        export namespace UserSetting {
            export const UPDATED = 'Updated';
            export const CONNECTED = 'Connection_succeeded';
        }
        export namespace MailSetting {
            export const UPDATED = 'Updated';
            export const CONNECTED = 'Connection_succeeded';
        }
        export namespace MultifactorAuth {
            export const ADD_HARD = 'Added_hardware_token';
            export const CHANGED = 'Changed_the_status';
            export const RESETED = 'Time_correction_value_has_been_reset';
            export const DEALLOCATED = 'User_unassigned';
            export const DESTROYED = 'Multifactor_authentication_device_deleted';
        }
        export namespace JobExecution {
            export const RETRY = 'Job_re-executed';
            export const CANCEL = 'Job_canceled';
        }
        export namespace Csv {
            export const OUTPUT = 'CSV_file_output_preparation_started';
        }
        export namespace DetectionRuleGroup {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Detection_rule_group_updated';
            export const DESTROYED = 'Detection_rule_group_deleted';
            export const ADD_RULES = 'Detection_rule_was_added_to_the_detection_rules_group';
            export const REMOVE_RULES = 'Detection_rule_excluded_from_detection_rules_group';
        }
        export namespace DetectionRule {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Detection_rule_updated';
            export const DESTROYED = 'Detection_rule_deleted';
        }
        export namespace Workflow {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Workflow_updated';
            export const DESTROYED = 'Workflow_deleted';
        }
        export namespace BusinessSystem {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Business_system_updated';
            export const DESTROYED = 'Business_system_deleted';
            export namespace ApplicationTemplate {
                export const CREATED = 'Created_name';
                export const UPDATED = 'Application_template_updated';
                export const DESTROYED = 'Application_template_deleted';
            }
            export namespace RoutineWorkTemplate {
                export const UPDATED = 'Routine_work_template_updated';
                export const DESTROYED = 'Routine_work_template_deleted';
            }
            export namespace AccountSet {
                export const CREATED = 'Created_name';
                export const UPDATED = 'Account_set_updated';
                export const DESTROYED = 'Account_Set_deleted';
            }
        }
        export namespace AutoLoginApp {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Auto_login_app_definition_updated';
            export const DESTROYED = 'Auto_login_app_definition_deleted';
        }
        export namespace WaitingApplication {
            export const DESTROYED = 'Application_form_deleted';
        }
        export namespace ApplicationForm {
            export const CREATED = 'Application_form_created';
            export const UPDATED = 'Application_form_updated';
            export const DRAFTED_CREATED = 'Drafted_created';
            export const DRAFTED_UPDATED = 'Drafted_updated';
            export const FILE_DESTROY = 'Attachment_file_deleted';
        }
        export namespace PrivilegedIdSetting {
            export const UPDATED = 'Updated';
        }
        export namespace PrivilegeIdLendingRecord {
            export const UPDATED = 'Updated';
        }
        export namespace SystemSetting {
            export const UPDATED = 'Updated';
        }
        export namespace FromAddressList {
            export const UPDATED = 'IP_Address_Information_Of_The_Connection_Source_updated';
        }
        export namespace RecSetting {
            export const UPDATED = 'Updated';
        }
        export namespace License {
            export const CREATED = 'License_registered';
            export const ACTIVATED = 'Activated';
            export const DESTROYED = 'License_deleted';
        }
        export namespace ExternalProgramUsage {
            export const CREATED = 'Registered_name';
            export const UPDATED = 'External_program_usage_updated';
            export const DESTROYED = 'External_program_usage_deleted';
        }
        export namespace NodeLoginHistoryExcludeCondition {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Node_login_history_exclude_condition_updated';
            export const DESTROYED = 'Node_login_history_exclude_condition_deleted';
        }
        export namespace ApplicationFormNumber {
            export const UPDATED = 'Application_form_number_information_updated';
            export const PREVIEW = 'Application_form_number_prefix_preview_get';
        }
        export namespace AccountInventorySetting {
            export const CREATED = 'Created_name';
            export const UPDATED = 'Account_inventory_setting_updated';
            export const EXECUTED = 'Account_inventory_executed';
            export const DESTROYED = 'Account_inventory_setting_deleted';
            export const ADD_NODE_GROUPS = 'Node_group_was_added_to_Account_inventory_setting';
            export const REMOVE_NODE_GROUPS = 'Node_group_was_excluded_from_Account_inventory_setting';
            export const ADD_NODE_DOMAINS = 'Node_domain_was_added_to_Account_inventory_setting';
            export const REMOVE_NODE_DOMAINS = 'Node_domain_was_excluded_from_Account_inventory_setting';
            export const UPDATED_SECURITY_GROUPS = 'Security_group_for_Target_Node_domain_was_updated';
        }
        export namespace AccountInventoryResult {
            export const DIFF = 'Account_inventory_result_diff';
            export const RETRY = 'Account_inventory_retried';
        }
    }

    /**
     * パスワード変更関連のジョブ名称一覧
     * @type string[]
     */
    export const PasswordRandomizeFailedJobs: string[] = [
        'periodic_targeting_to_change_os_account_password',
        'periodic_targeting_to_change_domain_account_password',
        'randomize_os_account_password',
        'randomize_domain_account_password',
        'randomize_other_account_password',
        'randomize_account_password',
    ];

    /**
     * SSL通信方式一覧
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const SSLEncryptions: { text_key: string; value: string }[] = [
        { text_key: 'SSL_TLS', value: 'ssl' },
        { text_key: 'STARTTLS', value: 'tls' },
        { text_key: 'Not_use', value: '' },
    ];

    /**
     * IdP一覧(ノードIdP)
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const NodeSamlIdpableList: { text_key: string; value: string }[] = [
        { text_key: 'Microsoft_Entra_ID', value: 'NodeSamlIdpMicrosoftEntraId' },
        { text_key: 'One_Login', value: 'NodeSamlIdpOneLogin' },
        { text_key: 'Okta', value: 'NodeSamlIdpOkta' },
    ];

    /**
     * IdP一覧
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}, {text_key: string; value: string}]}
     */
    export const IdPList: { text_key: string; value: string }[] = [
        { text_key: 'MicrosoftEntraID', value: 'microsoftentraid' },
        { text_key: 'OneLogin', value: 'onelogin' },
        { text_key: 'Okta', value: 'okta' },
    ];

    /**
     * ランダマイズ方式(通常ノード/ノードドメインアカウント)
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const RandomizeTypeList: { text_key: string; value: string }[] = [
        { text_key: 'Randomize_Comprehensive', value: 'comprehensive' },
        { text_key: 'Randomize_Periodical', value: 'periodical' },
        { text_key: 'Randomize_Manual', value: 'manual' },
    ];

    /**
     * ランダマイズ方式(シンプルノード)
     * @type {[{text_key: string; value: string}]}
     */
    export const RandomizeTypeManual: { text_key: string; value: string }[] = [
        { text_key: 'Randomize_Manual', value: 'manual' },
    ];

    /**
     * 認証方式
     */
    export namespace ConnectionType {
        export const PASSWORD = { text_key: 'Password', value: 'password', icon: 'fa-asterisk' };
        export const SSH_KEY = { text_key: 'SSH_Key', value: 'ssh_key', icon: 'fa-key' };
    }

    /**
     * 認証方式リスト
     * @type {[{text_key: string; value: string; icon: string} , {text_key: string; value: string; icon: string}]}
     */
    export const ConnectionTypeList: { text_key: string; value: string; icon: string }[] = [
        ConnectionType.PASSWORD,
        ConnectionType.SSH_KEY,
    ];

    /**
     * 多要素認証方式一覧
     * @type {[{text_key: string; value: string}, {text_key: string; value: string}]}
     */
    export const DeviceType: { text_key: string; value: string }[] = [
        { text_key: 'Google_Authenticator', value: 'soft' },
        { text_key: 'Hardware_Token', value: 'hard' },
    ];

    /**
     * 多要素認証利用可否一覧
     * @type {[{text_key: string; value: string }, {text_key: string; value: string }, {text_key: string; value: string }]}
     */
    export const MultifactorAuthenticateAvailability: { text_key: string; value: string }[] = [
        { text_key: 'Not_use', value: 'no' },
        { text_key: 'Invalid_(_Device_Assignment_Possible_)', value: 'disable' },
        { text_key: 'Valid', value: 'enable' },
    ];

    /**
     * ワンタイムパスワード発行間隔の選択項目
     * @type {[{text_key: string; value: string }]}
     */
    export const OnetimePasswordPeriod: { value: number }[] = [{ value: 30 }, { value: 60 }];

    /**
     * 多要素認証デバイス一覧のアクション項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const DeviceActions: { text_key: string; value: string }[] = [
        { text_key: 'Activation', value: 'activation' },
        { text_key: 'Invalidation', value: 'invalidation' },
        { text_key: 'Unassign_User', value: 'assigned_user_cancellation' },
        { text_key: 'Reset_Of_The_Time_Correction_Value', value: 'time_correction_reset' },
        { text_key: 'Delete_Device', value: 'delete_device' },
    ];

    /**
     * 公開API認証設定の認証方法一覧
     * @type {[{text_key: string; value: string}, {text_key: string; value: string}]}
     */
    export const AcceptAuth: { text_key: string; value: string }[] = [
        { text_key: 'ID/PW_Authentication', value: 'idpw' },
        { text_key: 'Access_Key_Authentication', value: 'key' },
    ];

    /**
     * アカウントロック解除方法項目
     * @type {[{text_key: string; value: string}]}
     */
    export const UnlockAccountMethods: { text_key: string; value: string }[] = [
        { text_key: 'Lapse_Of_Time', value: 'time' },
        { text_key: 'Mail', value: 'mail' },
        { text_key: 'Mail_Or_Lapse_Of_Time', value: 'mail_or_time' },
    ];

    /**
     * システム変更履歴 カテゴリ
     * @type {[{text_key: string; value: string }, {text_key: string; value: string }, {text_key: string; value: string }, {text_key: string; value: string }]}
     */
    export const SystemChangeHistoryCategory: { text_key: string; value: string }[] = [
        { text_key: 'User_Management', value: 'user' },
        { text_key: 'Privileged_ID_Management', value: 'node' },
        { text_key: 'Mail_Management', value: 'mail' },
        { text_key: 'System_Setting_Management', value: 'systemSetting' },
        { text_key: 'Account_Inventory_Setting_Management', value: 'accountInventorySetting' },
    ];

    /**
     * システム変更履歴 イベント
     * @type {[{text_key: string; value: string }, {text_key: string; value: string }, {text_key: string; value: string }]}
     */
    export const SystemChangeHistoryEvent: { text_key: string; value: string }[] = [
        { text_key: 'Create', value: 'create' },
        { text_key: 'Update', value: 'update' },
        { text_key: 'Delete', value: 'destroy' },
    ];
    /**
     * ジョブ実行履歴一覧アクション項目
     * @type {[{text_key: string; value: string}, {text_key: string; value: string}]}
     */
    export const JobMenuActions: { text_key: string; value: string }[] = [{ text_key: 'Retry', value: 'retry' }];

    export const ApplicationActions: { text_key: string; value: string }[] = [
        { text_key: 'Delete', value: 'application_delete' },
    ];

    /**
     * SSH鍵種別項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const SSHKeyTypeList: { text_key: string; value: string }[] = [
        { text_key: 'RSA_2048bit', value: 'RSA_2048' },
        { text_key: 'ECDSA_256bit', value: 'ECDSA_256' },
        { text_key: 'ECDSA_521bit', value: 'ECDSA_521' },
    ];

    /**
     * タイムゾーン項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const TimezoneList: { text_key: string; value: string }[] = [
        { text_key: 'JST', value: 'Asia/Tokyo' },
        { text_key: 'UTC', value: 'Etc/GMT' },
    ];

    /**
     * フィールド種別項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const FieldTypeList: { text_key: string; value: string }[] = [
        { text_key: 'Single_Line_Text', value: 'text_field' },
        { text_key: 'Multiple_Line_Text', value: 'text_area' },
        { text_key: 'Check_Box', value: 'check_box' },
        { text_key: 'Radio_Button', value: 'radio_button' },
        { text_key: 'Pull_Down', value: 'pull_down' },
        { text_key: 'User_Pick', value: 'user_pick' },
        { text_key: 'Date_And_Time', value: 'date_and_time' },
    ];

    /**
     * ノード管理対象項目
     * @type {[{text_key: string; value: number} , {text_key: string; value: number}]}
     */
    export const NodeModeList: { text_key: string; value: number }[] = [
        { text_key: 'Normal_Node', value: 1 },
        { text_key: 'Simple_Node', value: 2 },
    ];

    /**
     * 業務種別項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const BusinessTypeList: { text_key: string; value: string }[] = [
        { text_key: 'Normal_Business', value: 'normal' },
        { text_key: 'SAML_Federation_Business', value: 'saml' },
    ];

    /**
     * 時刻項目
     */
    export namespace TimesList {
        export const HOURS = Array.from(new Array(24)).map((v, i) => ('00' + i).slice(-2));
        export const MINUTES = Array.from(new Array(60)).map((v, i) => ('00' + i).slice(-2));
    }

    /**
     * 検知種別一覧
     * @type {[{text_key: string; value: string}, {text_key: string; value: number}]}
     */
    export const DetectionType: { text_key: string; value: number }[] = [
        { text_key: 'Partial_Match', value: 1 },
        { text_key: 'Regular_Expression', value: 2 },
    ];
    export namespace StepList {
        export const APPLICATION = 'Application';
        export const APPROVAL = Array.from(new Array(10)).map(v => 'Approval');
        export const WORK = 'Work';
        export const CONFIRMATION = Array.from(new Array(10)).map(v => 'Confirmation');
    }

    /**
     * アカウント種別(パスワード変更対象アカウント)
     */
    export namespace AccountTypeRandomizableAccount {
        export const MANAGEMENT = { text_key: 'Administrator_Account', value: 'management_account' };
        export const OS = { text_key: 'Worker_Account', value: 'os_account' };
        export const OTHER = { text_key: 'Worker_Account', value: 'other_account' };
        export const DOMAIN = { text_key: 'Registered_Accounts', value: 'domain_account' };
    }

    /**
     * アカウント種別一覧(パスワード変更対象アカウント)
     * @type {[{text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const AccountTypeRandomizableAccountList: { text_key: string; value: string }[] = [
        AccountTypeRandomizableAccount.MANAGEMENT,
        AccountTypeRandomizableAccount.OS,
        AccountTypeRandomizableAccount.OTHER,
        AccountTypeRandomizableAccount.DOMAIN,
    ];

    /**
     * アカウント種別一覧(種別名のみ)
     * @type {[{text_key: string; value: number}, {text_key: string; value: number}, {text_key: string; value: number}, {text_key: string; value: number}]}
     */
    export const AccountType: { text_key: string; value: number }[] = [
        { text_key: 'OS', value: 1 },
        { text_key: 'Domain', value: 2 },
        { text_key: 'Other', value: 3 },
        { text_key: 'IdP', value: 4 },
    ];

    /**
     * アカウント種別一覧([種別名]アカウント)
     * @type {[{text_key: string; value: number}, {text_key: string; value: number}, {text_key: string; value: number}, {text_key: string; value: number}]}
     */
    export const AccountTypeFullName: { text_key: string; value: number }[] = [
        { text_key: 'Os_Account', value: 1 },
        { text_key: 'Domain_Account', value: 2 },
        { text_key: 'Other_Account', value: 3 },
        { text_key: 'IdP_Account', value: 4 },
    ];

    /**
     * 申請書 ステータス
     * @type {{text_key: string; value: number}[]}
     */
    export const WorkflowStatusList: { text_key: string; value: number }[] = [
        { text_key: 'Waiting_For_Application', value: 1 },
        { text_key: 'Waiting_For_Approval', value: 2 },
        { text_key: 'Waiting_For_Work', value: 3 },
        { text_key: 'Waiting_For_Report', value: 4 },
        { text_key: 'Waiting_For_Confirmation', value: 5 },
        { text_key: 'Preparing_For_Work', value: 6 },
        { text_key: 'Working', value: 7 },
        { text_key: 'Working_In_Excess', value: 8 },
        { text_key: 'Rejected', value: 9 },
        { text_key: 'Finished', value: 10 },
        { text_key: 'Forced_Termination', value: 11 },
    ];

    /**
     * 申請履歴一覧のアクション項目
     * @type {{text_key: string; value:  ActionName }[]}
     */
    export const ApplicationFormActions: { text_key: string; value: ActionName }[] = [
        { text_key: 'Approval', value: 'approval' },
        { text_key: 'Reject', value: 'rejection' },
        { text_key: 'Confirmation', value: 'confirmation' },
        { text_key: 'Cancel_Workflow', value: 'pull_back' },
        { text_key: 'Send_Back_Workflow', value: 'send_back' },
        { text_key: 'Report_Work', value: 'work_report' },
        { text_key: 'Force_Terminate', value: 'forced_termination' },
    ];

    /**
     * ログイン履歴 ステータス
     * @type {{text_key: string; value: string}[]}
     */
    export const LoginHistoryStatusList: { text_key: string; value: string }[] = [
        { text_key: 'Illegality', value: 'illegal' },
        { text_key: 'Warning', value: 'warning' },
        { text_key: 'Unmanaged_Account', value: 'unmanaged_account' },
        { text_key: 'Management_Login', value: 'management_login' },
        { text_key: 'Normalcy', value: 'normal' },
        { text_key: 'Unmatched', value: 'unmatched' },
    ];

    /**
     * 個人設定 言語
     * @type {{text_key: string; value: string | null}[]}
     */
    export const PersonalSettingLanguageList: { text_key: string; value: string | null }[] = [
        { text_key: 'Not_Set', value: null },
        { text_key: 'Japanese', value: 'ja' },
        { text_key: 'English', value: 'en' },
    ];

    /**
     * 超過作業中の新規貸出可否
     * @type {{text_key: string; value: string}[]}
     */
    export const AllowedPrivilegedIdInExcess: { text_key: string; value: 1 | 2 }[] = [
        { text_key: 'Allow', value: 1 },
        { text_key: 'Not_Allow', value: 2 },
    ];

    /**
     * 動画フレームレート項目
     * @type {[{text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number}]}
     */
    export const VideoFrameRateList: { text_key: string; value: number }[] = [
        { text_key: '1', value: 1 },
        { text_key: '2', value: 2 },
        { text_key: '3', value: 3 },
        { text_key: '4', value: 4 },
        { text_key: '5', value: 5 },
    ];

    /**
     * 添付ファイル持ち出し期間項目
     * @type {[{text_key: string; value: any} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number}]}
     */
    export const FileExportExpirationDateList: { text_key: string; value: number }[] = [
        { text_key: 'None', value: 0 },
        { text_key: '1', value: 1 },
        { text_key: '3', value: 3 },
        { text_key: '7', value: 7 },
        { text_key: '14', value: 14 },
    ];

    /**
     * 重複申請禁止設定一覧
     * @type {[{text_key: string; value: string }, {text_key: string; value: string }, {text_key: string; value: string }]}
     */
    export const ProhibitNodeTypeList: { text_key: string; value: string }[] = [
        { text_key: 'Not_prohibited', value: 'none' },
        { text_key: 'Windows_server_and_rdp_only', value: 'windows_and_rdp' },
        { text_key: 'All_node_types', value: 'all' },
    ];

    /**
     * メール送信設定 言語
     * @type {{text_key: string; value: string}[]}
     */
    export const MailSendSettingLanguageList: { text_key: string; value: string }[] = [
        { text_key: 'Japanese', value: 'ja' },
        { text_key: 'English', value: 'en' },
    ];

    /**
     * URLスキーマ設定
     * @type {[{text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const AllowedSchemeSettingsList: { text_key: string; value: string }[] = [
        { text_key: 'https', value: 'https' },
        { text_key: 'http', value: 'http' },
    ];

    /**
     * ログイン履歴収集の収集方法項目
     * @type {[{text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number}]}
     */
    export const LoginHistoryCollectionMethodList: { text_key: string; value: string }[] = [
        { text_key: 'Collect_from_nodes', value: 'collect_from_nodes' },
        { text_key: 'Collect_from_folders', value: 'collect_from_folders' },
        { text_key: 'Do_not_collect', value: 'do_not_collect' },
    ];

    /**
     * ログイン失敗履歴の収集方法項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}]}
     */
    export const LoginFailureHistoryCollectionMethodList: { text_key: string; value: string }[] = [
        { text_key: 'Collect_from_nodes', value: 'collect_from_nodes' },
        { text_key: 'Collect_from_folders', value: 'collect_from_folders' },
        { text_key: 'Do_not_collect', value: 'do_not_collect' },
    ];

    /**
     * ログイン履歴収集の収集間隔時間（毎分）
     * @type {[{text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} ,
     *         {text_key: string; value: number} , {text_key: string; value: number}]}
     */
    export const LoginHistoryCollectionIntervalMinutes: { text_key: string; value: number }[] = [
        { text_key: '5', value: 5 },
        { text_key: '10', value: 10 },
        { text_key: '15', value: 15 },
        { text_key: '20', value: 20 },
        { text_key: '30', value: 30 },
    ];

    /**
     * ログイン履歴収集の収集間隔時間（毎時）
     * @type {[{text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number} , {text_key: string; value: number}]}
     */
    export const LoginHistoryCollectionIntervalHours: { text_key: string; value: number }[] = [
        { text_key: '1', value: 1 },
        { text_key: '2', value: 2 },
        { text_key: '3', value: 3 },
        { text_key: '6', value: 6 },
        { text_key: '12', value: 12 },
        { text_key: '24', value: 24 },
    ];

    /**
     * 会計年度年基準一覧
     * @type {[{text: string; value: number}]}
     */
    export const FiscalYearBase: { text: string; value: number }[] = [
        { text: 'Western_calendar_of_start_date', value: 1 },
        { text: 'Western_calendar_at_the_end_of_the_term', value: 2 },
    ];

    /**
     * プレフィックス種別一覧
     * @type {[{text: string; value: number}]}
     */
    export const PrefixType: { text: string; value: number }[] = [
        { text: 'Text', value: 1 },
        { text: 'fiscal_year', value: 2 },
        { text: 'Date', value: 3 },
    ];

    /**
     * プレフィックスの会計年度一覧
     * @type {[{text: string; value: string}]}
     */
    export const PrefixFiscalYear: { text: string; value: string }[] = [
        { text: 'YY', value: 'yy' },
        { text: 'YYYY', value: 'yyyy' },
    ];

    /**
     * プレフィックスの日付一覧
     * @type {[{text: string; value: string}]}
     */
    export const PrefixDate: { text: string; value: string }[] = [
        { text: 'YY', value: 'yy' },
        { text: 'YYYY', value: 'yyyy' },
        { text: 'MM', value: 'mm' },
        { text: 'DD', value: 'dd' },
        { text: 'MMDD', value: 'mmdd' },
        { text: 'YYMMDD', value: 'yymmdd' },
        { text: 'YYYYMMDD', value: 'yyyymmdd' },
    ];

    /**
     * アカウント棚卸結果詳細、差分結果詳細検索用ノード種別項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} , {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}, {text_key: string; value: string}]}
     */
    export const InventoryResultSearchNodeTypeList: { text_key: string; value: string }[] = [
        { text_key: 'WindowsServer2008_2008R2', value: 'Windows Server 2008 / 2008 R2' },
        { text_key: 'WindowsServer2012', value: 'Windows Server 2012' },
        { text_key: 'WindowsServer2012R2', value: 'Windows Server 2012 R2' },
        { text_key: 'WindowsServer2016', value: 'Windows Server 2016' },
        { text_key: 'WindowsServer2019', value: 'Windows Server 2019' },
        { text_key: 'WindowsServer2022', value: 'Windows Server 2022' },
        { text_key: 'WindowsServer2025', value: 'Windows Server 2025' },
        { text_key: 'RHEL', value: 'Red Hat Enterprise Linux' },
        { text_key: 'Cent_OS', value: 'Cent OS' },
        { text_key: 'AlmaLinux', value: 'AlmaLinux' },
        { text_key: 'Rocky_Linux', value: 'Rocky Linux' },
        { text_key: 'Oracle_linux', value: 'Oracle Linux' },
        { text_key: 'Amazon_linux', value: 'Amazon Linux' },
        { text_key: 'Ubuntu', value: 'Ubuntu' },
        { text_key: 'ESXi', value: 'ESXi' },
    ];

    /**
     * アカウント棚卸結果差分検索用変更された属性項目
     * @type {[{text_key: string; value: string} , {text_key: string; value: string} ]}
     */
    export const InventoryResultDiffChangeAttribute: { text_key: string; value: string }[] = [
        { text_key: 'Affiliation_Group', value: 'groups' },
        { text_key: 'Login_Shell', value: 'login_shell' },
    ];

    /**
     * 最大件数一覧
     */
    export namespace MaxCount {
        export const ACCOUNT_SEARCH = 1000;
        export const USER_GROUP_MEMBERS = 1000;
        export const NODE_DOMAIN_MEMBERS = 5000;
        export const NODE_IDP_MEMBERS = 5000;
        export const NODE_OS_MEMBERS = 2000;
        export const NODE_OTHER_MEMBERS = 2000;
        export const NODE_WORKER_ACCOUNT_AD_MEMBERS = 2000;
        export const NODE_WORKER_ACCOUNT_OS_MEMBERS = 2000;
        export const NODE_WORKER_ACCOUNT_OTHER_MEMBERS = 2000;
        export const NODE_WORKER_ACCOUNT_IDP_MEMBERS = 500;
        export const NODE_AUTO_LOGIN_APPS = 10;
        export const NODE_NODE_LOGIN_HSTORY_EXCLUDE_CONDITION = 1000;
        export const NODES_GROUP_MEMBERS = 200;
        export const DETECTION_RULE_GROUP_MEMBERS = 50;
        export const APPLICATION_TEMPLATES = 100;
        export const ROUTINE_WORK_TEMPLATES = 100;
        export const STEP_ITEMS = 10;
        export const ACCOUNT_SETS = 50;
        export const WORKFLOW_ITEMS = 100;
        export const CUSTOMIZED_FIELD_ITEMS = 30;
        export const PLACEHOLDER_FIELD_ITEMS = 10;
        export const APPLICATION_TEMPLATE_PERSONS_IN_CHARGE = 20;
        export const APPLICATION_TEMPLATE_DETECTION_RULE_MAIL_MEMBERS = 20;
        export const APPLICATION_TEMPLATE_WORKFLOW_TRANSITION_MAIL_MEMBERS = 20;
        export const APPLICATION_TEMPLATE_DETECTION_RULE_MAIL_TOTAL_MEMBERS = 60;
        export const APPLICATION_TEMPLATE_WORKFLOW_TRANSITION_MAIL_TOTAL_MEMBERS = 60;
        export const ROUTINE_WORK_TEMPLATE_DETECTION_RULE_MAIL_MEMBERS = 20;
        export const ROUTINE_WORK_TEMPLATE_DETECTION_RULE_MAIL_TOTAL_MEMBERS = 60;
        export const ACCOUNT_SET_WORKERS = 100;
        export const ACCOUNT_SET_NODE_ACCOUNTS = 500;
        export const ACCOUNT_SET_SAML_NODE = 500;
        export const UNIT_OF_WORK_COUNT = 50;
        export const ATTACHMENTS_COUNT = 10;
        export const NODE_PLACEHOLDER_ITEMS = 50;
        export const ACCESS_KEYS_ITEMS = 2;
        export const PREFIX_ITEMS = 10;
    }

    /**
     * ファイルサイズ一覧
     */
    export namespace FileSize {
        export const FILE_SIZE_GB = Math.pow(1024, 3);
        export const FILE_SIZE_MB = Math.pow(1024, 2);
        export const FILE_SIZE_KB = Math.pow(1024, 1);
        export const MIN_FILE_SIZE = 1;
        export const MAX_FILE_SIZE = FILE_SIZE_GB * 2;
        export const DISPLAY_MAX_FILE_SIZE = 2;
        export const MAX_FILE_NAME_SIZE = 255;
    }

    /**
     * 申請書に関する操作一覧
     */
    export namespace UsableActions {
        export const APPLICATION_ACTION = 'application' as ActionName;
        export const APPROVAL_ACTION = 'approval' as ActionName;
        export const REJECTION_ACTION = 'rejection' as ActionName;
        export const CONFIRMATION_ACTION = 'confirmation' as ActionName;
        export const WORK_REPORT_ACTION = 'work_report' as ActionName;
        export const PULL_BACK_ACTION = 'pull_back' as ActionName;
        export const SEND_BACK_ACTION = 'send_back' as ActionName;
        export const FORCED_TERMINATION_ACTION = 'forced_termination' as ActionName;
        export const REUSE_ACTION = 'reuse' as ActionName;
    }

    /**
     * 申請書に関するロール一覧
     */
    export namespace ApplicationFormRoles {
        export const APPLICATION_ROLE = 'application';
        export const APPROVAL_ROLE = 'approval';
        export const WORKING_ROLE = 'working';
        export const CONFIRMATION_ROLE = 'confirmation';
    }

    /**
     * 検知記録関連
     */
    export namespace DetectionLogs {
        export const MAX_ITEMS = 500;
    }

    /**
     * SAML認証情報のAdminONEサイトURLを基に生成するURLの末尾につく文字列
     */
    export namespace SAMLCredentialsOtherPass {
        export const IDENTIFIER_PATH = 'saml/metadata';
        export const ACS_URL_FOR_SITE_PATH = 'api/saml/verify';
        export const ACS_URL_FOR_OA_PATH = 'api/saml/oa';
        export const ACS_URL_FOR_OAFB_PATH = 'api/saml/oafb';
    }

    /**
     * 特権ID管理設定画面のSAML連携情報のAdminONEサイトURLを基に生成するURLの末尾につく文字列
     */
    export namespace NodeIdpSamlFederationInformationOtherPath {
        export const ENTITY_ID_PATH = 'api/node_samls/';
        export const LOGIN_URL_PATH = 'api/node_samls/idp/sso/';
        export const ACS_URL_PATH = 'api/node_samls/sp/acs/';
    }

    /**
     * プロフィール定数情報
     */
    export namespace Profile {
        export namespace Menu {
            export const LIST = [
                {
                    icon: 'fa-user',
                    text: 'Profile',
                    execute: (caller: any): void => {
                        caller.$router.push(ScreenUrl.User.SHOW.replace(':id', caller.id().toString()));
                    },
                },
                {
                    icon: 'fa-file',
                    text: 'Output_File',
                    execute: (caller: any): void => {
                        caller.$router.push(ScreenUrl.Csv.INDEX);
                    },
                },
                {
                    icon: 'fa-user-cog',
                    text: 'Personal_Setting',
                    execute: (caller: any): void => {
                        caller.$router.push(ScreenUrl.PersonalSetting.INDEX);
                    },
                },
                {
                    icon: 'fa-sign-out-alt',
                    text: 'Logout',
                    execute: (caller: any): void => {
                        caller.logout();
                    },
                },
            ];
        }
    }

    /**
     * アクション項目情報
     */
    export interface MenuAction {
        text_key: string;
        value: string;
    }

    /**
     * ナビゲーションバー情報
     */
    export namespace NavigationBar {
        export interface Type {
            subheader?: string;
            icon?: string;
            text?: string;
            url?: string;
            can?: string;
            active?: boolean;
            children?: Array<any>;
        }
        // サービス一覧
        export const SERVICE_LIST = [
            {
                subheader: 'Privileged_ID_Management',
                children: [
                    {
                        icon: 'fa-cube',
                        text: 'Node_Management',
                        can: 'search NodeDomain',
                        children: [
                            {
                                text: 'Node_Domains',
                                url: ScreenUrl.NodeDomain.INDEX,
                                can: 'search NodeDomain',
                            },
                            {
                                text: 'Node_IdPs',
                                url: ScreenUrl.NodeIdp.INDEX,
                                can: 'search NodeIdp',
                            },
                            {
                                text: 'Node',
                                url: ScreenUrl.Node.INDEX,
                                can: 'search Node',
                            },
                            {
                                text: 'Node_Groups',
                                url: ScreenUrl.NodeGroup.INDEX,
                                can: 'search NodeGroup',
                            },
                        ],
                    },
                    {
                        icon: 'fa-project-diagram',
                        text: 'Workflow_Management',
                        url: ScreenUrl.Workflow.INDEX,
                        can: 'search Workflow',
                    },
                    {
                        icon: 'fa-bell',
                        text: 'Detection_Rule_Management',
                        can: 'search DetectionRule',
                        children: [
                            {
                                text: 'Detection_Rule',
                                url: ScreenUrl.DetectionRule.INDEX,
                                can: 'search DetectionRule',
                            },
                            {
                                text: 'Detection_Rule_Group',
                                url: ScreenUrl.DetectionRuleGroup.INDEX,
                                can: 'search DetectionRuleGroup',
                            },
                        ],
                    },
                    {
                        icon: 'fa-object-group',
                        text: 'Business_System_Management',
                        url: ScreenUrl.BusinessSystem.INDEX,
                        can: 'search BusinessSystem',
                    },
                    {
                        icon: 'fa-list-ul',
                        text: 'Account_Inventory_Setting_Management',
                        url: ScreenUrl.AccountInventorySetting.INDEX,
                        can: 'search AccountInventorySetting',
                    },
                    {
                        icon: 'apps',
                        text: 'Automatic_Login_Application_Definition_Management',
                        url: ScreenUrl.AutoLoginApp.INDEX,
                        can: 'search AutoLoginApp',
                    },
                    {
                        icon: 'fa-external-link-alt',
                        text: 'External_Program_Usage_Information_Management',
                        url: ScreenUrl.ExternalProgramUsage.INDEX,
                        can: 'index ExternalProgramUsage',
                    },
                    {
                        icon: 'fa-eraser',
                        text: 'Node_Login_History_Exclude_Condition_Management',
                        url: ScreenUrl.NodeLoginHistoryExcludeCondition.INDEX,
                        can: 'search NodeLoginHistoryExcludeCondition',
                    },
                    {
                        icon: 'fa-file',
                        text: 'Application',
                        active: true,
                        // TODO:ロールの制御を入れる
                        children: [
                            {
                                text: 'Work_Application',
                                url: ScreenUrl.ApplicationFormTemplate.INDEX,
                            },
                            {
                                text: 'Draft_and_Waiting_Application',
                                url: ScreenUrl.WaitingApplication.INDEX,
                            },
                        ],
                    },
                    {
                        icon: 'fa-clipboard-list',
                        text: 'List',
                        children: [
                            {
                                // TODO:ロールの制御を入れる
                                text: 'Application_Form_List',
                                url: ScreenUrl.ApplicationForm.INDEX,
                            },
                            {
                                text: 'Privilege_ID_Lending_History',
                                url: ScreenUrl.privilegeIdLendingRecord.INDEX,
                            },
                            {
                                text: 'Node_Login_History',
                                url: ScreenUrl.LoginRecord.INDEX,
                                can: 'search LoginRecord',
                            },
                            {
                                text: 'Node_Login_Failure_History',
                                url: ScreenUrl.LoginFailureRecord.INDEX,
                                can: 'search LoginFailureRecord',
                            },
                            {
                                text: 'Rule_Detection_History',
                                url: ScreenUrl.DetectionRulesRecord.INDEX,
                                can: 'search NodeDomain',
                            },
                            {
                                text: 'Account_Inventory_Result',
                                url: ScreenUrl.AccountInventoryResult.INDEX,
                                can: 'search AccountInventoryResult',
                            },
                            {
                                text: 'Account_Inventory_Result_Diff',
                                url: ScreenUrl.AccountInventoryResultDiff.INDEX,
                                can: 'search AccountInventoryResultDiff',
                            },
                        ],
                    },
                ],
            },
        ];
        // 管理メニュー一覧
        export const ADMIN_MENU_LIST = [
            {
                subheader: 'User_Management',
                children: [
                    {
                        icon: 'person',
                        text: 'User',
                        url: ScreenUrl.User.INDEX,
                        can: 'search User',
                    },
                    {
                        icon: 'group',
                        text: 'User_Groups',
                        url: ScreenUrl.UserGroup.INDEX,
                        can: 'search UserGroup',
                    },
                ],
            },
            {
                subheader: 'List',
                children: [
                    {
                        icon: 'fa-history',
                        text: 'System_Change_History',
                        url: ScreenUrl.SystemChangeHistory.INDEX,
                        can: 'search SystemChangeHistory',
                    },
                    {
                        icon: 'fa-hourglass-end',
                        text: 'Job_History',
                        url: ScreenUrl.JobExecutionHistory.INDEX,
                        can: 'search JobExecutionHistory',
                    },
                    {
                        icon: 'phonelink_lock',
                        text: 'Multi-Factor_Authenticate_Device_Management',
                        url: ScreenUrl.MultifactorAuth.INDEX,
                        can: 'search MultifactorAuth',
                    },
                ],
            },
            {
                icon: 'settings',
                subheader: 'System_Settings',
                children: [
                    {
                        icon: 'fa-server',
                        text: 'Server_Settings',
                        url: ScreenUrl.SysPre.Server.SHOW,
                        can: 'show SystemSetting',
                    },
                    {
                        icon: 'fa-user-cog',
                        text: 'User_Authenticate_Management',
                        url: ScreenUrl.SysPre.UserDomain.SHOW,
                        can: 'show UserSetting',
                    },
                    {
                        icon: 'mail',
                        text: 'Mail_Settings',
                        url: ScreenUrl.SysPre.Mail.SHOW,
                        can: 'show MailSetting',
                    },
                    {
                        icon: 'security',
                        text: 'License_Management',
                        url: ScreenUrl.License.INDEX,
                        can: 'index License',
                    },
                    {
                        icon: 'verified_user',
                        text: 'Privileged_ID_Management',
                        url: ScreenUrl.PrivilegedIdSetting.SHOW,
                        can: 'show AppManagementNumber',
                    },
                    {
                        icon: 'videocam',
                        text: 'ESS_REC_Linkage_Setting',
                        url: ScreenUrl.RecLinkageSetting.INDEX,
                        can: 'show RecLinkageSetting',
                    },
                ],
            },
        ];
    }
}
